export default __webpack_public_path__ + "static/media/section1-measure1.1b53ef72.svg";